import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableFooter from '@material-ui/core/TableFooter';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import DeleteIcon from '@material-ui/icons/DeleteOutline';
import MoreIcon from '@material-ui/icons/MoreHoriz';
import React, { Component } from 'react';
import { SizeMe } from 'react-sizeme';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import { CustomTableCell, TablePaginationActionsWrapped } from '../../../../custom/table';
import { getWidthColumnByPercent, copyTextToClipboard } from '../../../../lib/components/function';
import { ioteraConfirmAlert } from '../../../../lib/components/react/react-confirm-alert';

/* Object Json */
import { safeDeepGet, safeDeepGetWithType, stringify, stringifyFormatted, size } from 'iotera-base/json';
import { isArray, isInteger, isObject, isEmpty } from 'iotera-base/object';

export class DialogVarList extends Component {
  constructor(props) {
    super(props);
    let isGlobal = safeDeepGetWithType(props, ['isGlobal'], false)
    this.state = {
      varType: 'str',
      pageG: 0,
      rowsPerPageG: 5,
      pageL: 0,
      rowsPerPageL: 5,
      varKey: null,
      isGlobal
    }
    this.handleClickVar = this.handleClickVar.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.executeDelete = this.executeDelete.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
  }

  handleClickVar = (var_key) => {
    const _this = this
    const _props = _this.props
    const key = '{' + var_key + '}'
    copyTextToClipboard(key);
    const _parent = safeDeepGet(_props, ['_parent']);
    _parent.setState({
      dialogListVar: false
    })
    _parent.props.showSingleNotification({ message: 'Variable key sudah di-copy ke clipboard', level: 'info' });
  }

  handleClose() {
    const _this = this
    const _props = _this.props
    const _parent = safeDeepGet(_props, ['_parent']);
    _parent.setState({
      dialogListVar: false
    })
    _this.setState({ pageL: 0 })
  }

  handleChangePageG = (event, page) => {
    this.setState({ pageG: page });
  };

  handleChangeRowsPerPageG = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ pageG: 0, rowsPerPageG: rowsPerPage });
  };

  handleChangePageL = (event, page) => {
    this.setState({ pageL: page });
  };

  handleChangeRowsPerPageL = event => {
    let rowsPerPage = event.target.value;
    if (!isInteger(rowsPerPage))
      rowsPerPage = parseInt(rowsPerPage)
    this.setState({ pageL: 0, rowsPerPageL: rowsPerPage });
  };

  handleEdit = key => event => {
  }

  handleDelete = key => event => {
    const _this = this
    const _props = _this.props
    let _parent = safeDeepGet(_props, ['_parent']);
    let varLocal = safeDeepGetWithType(_parent, ['state', '_var'], {});
    _parent.setState({ dialogListVar: false })
    ioteraConfirmAlert(
      'Konfirmasi Hapus Variabel',
      'Apakah anda yakin ingin menghapus variabel ini?',
      null,
      () => _this.executeDelete(key, varLocal),
      null,
      () => _parent.setState({ dialogListVar: true })
    )
  }

  executeDelete = (key, _var) => {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let _parent = safeDeepGet(_props, ['_parent']);
    if (key in _var) {
      delete _var[key]
    }
    let pageL = safeDeepGet(_state, ['pageL'], 0);
    let rowsPerPageL = safeDeepGet(_state, ['rowsPerPageL'], 5);
    const varLokLength = size(_var);
    const currPage = Math.floor((varLokLength - 1) / rowsPerPageL)
    if (currPage < pageL) {
      pageL = currPage
    }
    let varGlobal = safeDeepGetWithType(_parent, ['state', 'varGlobal'], {});
    let dialogListVar = true;
    if (isEmpty(_var) && isEmpty(varGlobal)) {
      dialogListVar = false;
    }
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen, pageL });
    _parent.setState({ _var, dialogListVar })
  }

  onMouseEnter = key => event => {
    const _this = this
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown visible 
    dropdownOpen[key] = true;
    _this.setState({ dropdownOpen });
  }

  onMouseLeave = key => event => {
    const _this = this
    const _state = _this.state
    let dropdownOpen = Object.assign({}, _state.dropdownOpen);
    // set dropdown hidden 
    dropdownOpen[key] = false;
    _this.setState({ dropdownOpen });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    let _parent = safeDeepGet(_props, ['_parent']);
    let { pageG, rowsPerPageG, pageL, rowsPerPageL } = _state;
    let varGlobal = safeDeepGetWithType(_parent, ['state', 'varGlobal'], {});
    let varLocal = safeDeepGetWithType(_parent, ['state', '_var'], {});
    let showAction = safeDeepGetWithType(_parent, ['state', 'hasAction'], true)
    let varGlobalArr = []
    for (let keys in varGlobal) {
      let value = varGlobal[keys];
      let type = 'string'
      if (isObject(value)) {
        value = stringifyFormatted(value)
        type = 'obj'
      }
      if (isArray(value)) {
        value = '[' + value.toString() + ']'
        type = 'arr'
      }
      varGlobalArr.push(
        {
          key: keys,
          value,
          type
        }
      )
    }
    let varLocalArr = []
    for (let keyss in varLocal) {
      let value = varLocal[keyss];
      let type = 'text'
      if (isObject(value)) {
        type = 'obj'
        let tempValue = { ...value }
        delete tempValue.queryType;
        delete tempValue._varType;
        value = stringify(tempValue)
      }
      if (isArray(value)) {
        value = '[' + value.toString() + ']'
        type = 'arr'
      }
      varLocalArr.push(
        {
          key: keyss,
          value,
          type
        }
      )
    }
    let dialogOpen = safeDeepGet(_parent, ['state', 'dialogListVar']);
    if (varGlobalArr.length === 0 && varLocalArr.length === 0) {
      dialogOpen = false;
    }
    return (
      <Dialog
        disableBackdropClick={true}
        open={dialogOpen}
        onClose={_this.handleClose}
        aria-labelledby="max-width-dialog-title"
        fullWidth={true}
        maxWidth={'md'}
      >
        <DialogTitle id="form-dialog-title">Daftar Variabel</DialogTitle>
        <DialogContent >
          {varGlobalArr.length > 0 &&
            <SizeMe>{({ size }) =>
              <div>
                <div className="h5">Variabel Global (dibentuk saat pertama kali membuat dashboard ini)</div>
                <div className="table-responsive">
                  <Table className="table">
                    <TableHead style={{ height: 0 }}>
                      <TableRow>
                        <CustomTableCell style={{ minWidth: getWidthColumnByPercent(40, size.width - 140), 
                          maxWidth: getWidthColumnByPercent(40, size.width - 140) }}>Key</CustomTableCell>
                        <CustomTableCell style={{ minWidth: getWidthColumnByPercent(60, size.width - 140), 
                          maxWidth: getWidthColumnByPercent(60, size.width - 140) }}>Nilai</CustomTableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {varGlobalArr.slice(pageG * rowsPerPageG, pageG * rowsPerPageG + rowsPerPageG).map((item, i) =>
                        <TableRow key={i} className='table-row-child-iotera'>
                          <TableCell >
                            <span className='link-iotera' onClick={() => _this.handleClickVar(item.key)} >
                              {item.key}
                            </span>
                          </TableCell>
                          <TableCell >
                            {item.value}
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                    {varGlobalArr.length > 5 &&
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
                            labelRowsPerPage='Baris terlihat:'
                            rowsPerPageOptions={[5]}
                            count={varGlobalArr.length}
                            rowsPerPage={rowsPerPageG}
                            page={pageG}
                            SelectProps={{
                              native: true,
                            }}
                            onPageChange={_this.handleChangePageG}
                            onChangeRowsPerPage={_this.handleChangeRowsPerPageG}
                            ActionsComponent={TablePaginationActionsWrapped}
                          />
                        </TableRow>
                      </TableFooter>
                    }
                  </Table>
                </div>
              </div>
            }</SizeMe>
          }
          {varLocalArr.length > 0 &&
            <SizeMe>{({ size }) =>
              <div>
                <div className="h5">{_state.isGlobal ? 'Variabel Global' : 'Variabel Lokal'}</div>
                <div className="table-responsive">
                  <Table className="table">
                    <TableHead style={{ height: 0 }}>
                      <TableRow>
                        <CustomTableCell style={{ minWidth: getWidthColumnByPercent(35, size.width - 140), 
                          maxWidth: getWidthColumnByPercent(35, size.width - 140) }}>Key</CustomTableCell>
                        <CustomTableCell style={{ minWidth: getWidthColumnByPercent(60, size.width - 140), 
                          maxWidth: getWidthColumnByPercent(60, size.width - 140) }}>Nilai</CustomTableCell>
                        {showAction &&
                          <CustomTableCell style={{ textAlign: 'center', minWidth: getWidthColumnByPercent(5, size.width - 140), 
                          maxWidth: getWidthColumnByPercent(5, size.width - 140) }}>Aksi</CustomTableCell>
                        }
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {varLocalArr.slice(pageL * rowsPerPageL, pageL * rowsPerPageL + rowsPerPageL).map((item, i) =>
                        <TableRow key={item.key} className='table-row-child-iotera'>
                          <TableCell >
                            {_state.isGlobal ?
                              item.key :
                              <span className='link-iotera' onClick={() => _this.handleClickVar(item.key)} >
                                {item.key}
                              </span>
                            }
                          </TableCell>
                          <TableCell >
                            {item.value}
                          </TableCell>
                          {showAction &&
                            <TableCell style={{ textAlign: 'center' }} onMouseLeave={_this.onMouseLeave(item.key)}>
                              <UncontrolledDropdown isOpen={safeDeepGetWithType(_state, ['dropdownOpen', item.key], false)} >
                                <DropdownToggle tag="div">
                                  <IconButton onMouseOver={_this.onMouseEnter(item.key)} style={{ cursor: 'pointer', padding: 4 }}>
                                    <MoreIcon color="inherit" style={{ height: 30, width: 30 }} />
                                  </IconButton>
                                </DropdownToggle>
                                <DropdownMenu style={{ padding: 0, margin: 0 }}>
                                  <DropdownItem style={{ margin: 0 }} onClick={_this.handleDelete(item.key)}>
                                    <DeleteIcon color="inherit" style={{ height: 18, width: 18 }} />&emsp;<span
                                     style={{ marginRight: 20 }}>Hapus</span>
                                  </DropdownItem>
                                </DropdownMenu>
                              </UncontrolledDropdown>
                            </TableCell>
                          }
                        </TableRow>
                      )}
                    </TableBody>
                    {varLocalArr.length > 5 &&
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            labelDisplayedRows={({ from, to, count }) => `${from}-${to} dari ${count}`}
                            labelRowsPerPage='Baris terlihat:'
                            rowsPerPageOptions={[5]}
                            count={varLocalArr.length}
                            rowsPerPage={rowsPerPageL}
                            page={pageL}
                            SelectProps={{
                              native: true,
                            }}
                            onPageChange={_this.handleChangePageL}
                            onChangeRowsPerPage={_this.handleChangeRowsPerPageL}
                            ActionsComponent={TablePaginationActionsWrapped}
                          />
                        </TableRow>
                      </TableFooter>
                    }
                  </Table>
                </div>
              </div>
            }</SizeMe>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={_this.handleClose} color="primary">Tutup</Button>
        </DialogActions>
      </Dialog>
    )
  }
}